import React from 'react';
import PropTypes from 'prop-types';
import { Search, Bell } from 'lucide-react';
import Select from 'react-select';
import styles from './RecommendationHeader.module.css';

const NotificationBell = ({ count = 0, onClick }) => (
  <button className={styles.notificationBell} onClick={onClick}>
    <Bell className={styles.bellIcon} />
    {count > 0 && <span className={styles.badge}>{count}</span>}
  </button>
);

export const RecommendationHeader = ({ 
  title = 'Recommendation Center',
  searchValue,
  onSearchChange,
  sortBy,
  onSortChange,
  actionPack,
  onActionPackChange,
  sortOptions = [],
  actionPackOptions = [],
  notificationCount = 0
}) => {
  return (
    <header className={styles.header}>
      <div className={styles.titleSection}>
        <h1 className={styles.title}>{title}</h1>
      </div>

      <div className={styles.filtersSection}>
        {/* Search Input */}
        <div className="time-input-interval">
        <div className={styles.searchContainer}>
          <Search className={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            className={styles.searchInput}
          />
        </div>
        </div>


        {/* Sort By Dropdown */}
        <div className="action-dropdown">
        <div className={styles.filterContainer}>
          <Select
            value={sortOptions.find(option => option.value === sortBy)}
            onChange={(option) => onSortChange(option.value)}
            options={sortOptions}
            className={styles.select}
            classNamePrefix="react-select"
            isSearchable={false}
            menuPlacement="auto"
            placeholder="Sort By"
            theme={(theme) => ({
              ...theme,
              borderRadius: 6,
              colors: {
                ...theme.colors,
                primary25: "#2a2a2a",
                primary50: "#1f1f1f",
                primary: "#232526",
                neutral0: "#1a1a1a",
                neutral20: "#404040",
                neutral80: "#fff",
              },
            })}
            styles={{
              control: (base) => ({
                ...base,
                backgroundColor: "#1a1a1a",
                borderColor: "#404040",
                minHeight: 36,
                height: 36,
                minWidth: 130,
              }),
              singleValue: (base) => ({
                ...base,
                color: "#fff",
              }),
              menu: (base) => ({
                ...base,
                backgroundColor: "#1a1a1a",
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? "#f51032"
                  : state.isFocused
                  ? "#2a2a2a"
                  : "#1a1a1a",
                color: "#fff",
              }),
            }}
          />
        </div>
        </div>

        {/* Action Pack Dropdown */}
        <div className="action-dropdown">
        <div className={styles.filterContainer}>
          <Select
            value={actionPackOptions.find(option => option.value === actionPack)}
            onChange={(option) => onActionPackChange(option.value)}
            options={actionPackOptions}
            className={styles.select}
            classNamePrefix="react-select"
            isSearchable={false}
            menuPlacement="auto"
            placeholder="Action Pack"
            theme={(theme) => ({
              ...theme,
              borderRadius: 6,
              colors: {
                ...theme.colors,
                primary25: "#2a2a2a",
                primary50: "#1f1f1f",
                primary: "#232526",
                neutral0: "#1a1a1a",
                neutral20: "#404040",
                neutral80: "#fff",
              },
            })}
            styles={{
              control: (base) => ({
                ...base,
                backgroundColor: "#1a1a1a",
                borderColor: "#404040",
                minHeight: 36,
                height: 36,
                minWidth: 120,
              }),
              singleValue: (base) => ({
                ...base,
                color: "#fff",
              }),
              menu: (base) => ({
                ...base,
                backgroundColor: "#1a1a1a",
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? "#f51032"
                  : state.isFocused
                  ? "#2a2a2a"
                  : "#1a1a1a",
                color: "#fff",
              }),
            }}
          />
        </div>
        </div>
      </div>
    </header>
  );
};

NotificationBell.propTypes = {
  count: PropTypes.number,
  onClick: PropTypes.func,
};

RecommendationHeader.propTypes = {
  title: PropTypes.string,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
  sortBy: PropTypes.string,
  onSortChange: PropTypes.func.isRequired,
  actionPack: PropTypes.string,
  onActionPackChange: PropTypes.func.isRequired,
  sortOptions: PropTypes.array,
  actionPackOptions: PropTypes.array,
  notificationCount: PropTypes.number
};